import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'antd';

import { useNotifications } from 'components/Notifications/hooks/useNotifications';

import {
  selectNotificationsLoading,
  selectUnreadNotifications
} from 'features/notifications/notificationsSelectors';

import usePageviewEvent from 'hooks/usePageViewEvent';
import { useAppSelector } from 'hooks/useTypedRedux';

import { GTMEventLogger } from 'utils/analytics';

import { GTMEvents } from 'constants/enums';

import NotificationCard from '../NotificationCard/NotificationCard';
import styles from './NotificationsView.module.scss';

const NotificationsView = () => {
  const { t } = useTranslation();
  const unreadNotifications = useAppSelector(selectUnreadNotifications);
  const isNotificationsLoading = useAppSelector(selectNotificationsLoading);

  const { loadUnreadNotifications, readAllNotifications, readNotification } =
    useNotifications();

  useEffect(() => {
    loadUnreadNotifications();
  }, [loadUnreadNotifications]);

  usePageviewEvent(GTMEvents.NotificationView);

  const isEmpty = !unreadNotifications?.length;

  if (isNotificationsLoading && isEmpty) {
    return <aside>{t('common.loading')}</aside>;
  }

  const handleReadAllClick = () => {
    GTMEventLogger(GTMEvents.NotificationViewReadAll);
    readAllNotifications();
  };

  return (
    <aside>
      <div className={styles.top}>
        <div className={styles.title}>{t('notification.title')}</div>
        {!isEmpty && (
          <Button type="link" onClick={handleReadAllClick}>
            {t('notification.readAll')}
          </Button>
        )}
      </div>

      {isEmpty ? (
        <div className={styles.empty}>{t('common.empty')}</div>
      ) : (
        <div className={styles.list}>
          {unreadNotifications.map((notification) => (
            <NotificationCard
              key={notification.id}
              notification={notification}
              onReadNotification={readNotification}
            />
          ))}
        </div>
      )}
    </aside>
  );
};

export default NotificationsView;
